import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, NewsletterSection, Features, Team, Partners, Banner, Events, Preventions, Mission, Campaigns, ReportSection } from '../../sections';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <Features /> {/* Features Section */}
      <About /> {/* About Section */}
      <Counter /> {/* Counter Section */}
      <Services /> {/* Services Slider */}
      <Mission /> {/* Mission section */}
      <ReportSection /> {/* Report Section */}
      <Banner /> {/* Banner Section */}
      <Events /> {/* Events Slider */}
      <Testimonials /> {/* Testimonials Slider */}
      <Team /> {/* Team section */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Campaigns /> {/* Campaigns Slider */}
      <Blogs /> {/* Latest blog posts */}
      <Preventions /> {/* Preventions Slider */}
      <Partners /> {/* Partners Slider */}
    </div>
  )

}

export default HomePage;